<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <a-tabs default-active-key="map">
          <!-- ========== Tab1：商品映射 ========== -->
          <a-tab-pane tab="商品映射" key="map">
            <div class="table-page-search-wrapper">
              <a-form layout="inline" @keyup.enter.native="searchQuery">
                <a-row :gutter="24">
                  <a-col :md="6" :sm="24">
                    <a-form-item label="商品名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input placeholder="请输入商品名称查询" v-model="queryParam.materialName"></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="合作伙伴" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-select placeholder="请选择伙伴" allow-clear v-model="queryParam.partnerTenantId">
                        <a-select-option v-for="p in partnerList" :key="p.partnerTenantId" :value="p.partnerTenantId">
                          {{ p.partnerName }}（{{ p.partnerTenantId }}）
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-select placeholder="全部状态" allow-clear v-model="queryParam.status">
                        <a-select-option value="0">待对方处理</a-select-option>
                        <a-select-option value="1">已生效</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                    <a-col :md="12" :sm="24">
                      <a-button type="primary" @click="searchQuery">查询</a-button>
                      <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                    </a-col>
                  </span>
                </a-row>
              </a-form>
            </div>
            <div class="table-operator" style="margin-top: 5px">
              <a-button v-if="btnEnableList.indexOf(1)>-1" type="primary" icon="plus" @click="handleAdd">新增映射</a-button>
            </div>
            <section>
              <a-table
                ref="table"
                size="middle"
                bordered
                rowKey="id"
                :columns="columns"
                :dataSource="dataSource"
                :pagination="false"
                :scroll="scroll"
                :loading="loading"
                @change="handleTableChange">
                <template slot="source" slot-scope="text">
                  <a-tag v-if="text === 'manual'">手动</a-tag>
                  <a-tag v-else-if="text === 'share'" color="blue">分享</a-tag>
                  <a-tag v-else-if="text === 'claim'" color="purple">认领</a-tag>
                  <span v-else>{{ text }}</span>
                </template>
                <template slot="status" slot-scope="text">
                  <a-tag v-if="text === '0'" color="orange">待对方处理</a-tag>
                  <a-tag v-else color="green">已生效</a-tag>
                </template>
                <span slot="action" slot-scope="text, record">
                  <a-popconfirm v-if="btnEnableList.indexOf(1)>-1" title="确定删除该映射吗?"
                                @confirm="() => handleDelete(record.id)">
                    <a>删除</a>
                  </a-popconfirm>
                </span>
              </a-table>
            </section>
            <a-pagination
              style="margin-top: 16px; text-align: right"
              :current="ipagination.current"
              :pageSize="ipagination.pageSize"
              :total="ipagination.total"
              @change="paginationChange"
              @showSizeChange="paginationShowSizeChange"
            />
            <item-map-modal ref="modalForm" @ok="modalFormOk"></item-map-modal>
          </a-tab-pane>

          <!-- ========== Tab2：商品别名 ========== -->
          <a-tab-pane tab="商品别名" key="alias">
            <div class="table-page-search-wrapper">
              <a-form layout="inline" @keyup.enter.native="loadAliases(1)">
                <a-row :gutter="24">
                  <a-col :md="6" :sm="24">
                    <a-form-item label="别名" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input placeholder="请输入别名查询" v-model="aliasQueryParam.alias"></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="客户" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-select placeholder="全部（含客户专属）" allow-clear v-model="aliasQueryParam.customerTenantId">
                        <a-select-option :value="0">通用（所有客户）</a-select-option>
                        <a-select-option v-for="p in customerPartnerList" :key="p.partnerTenantId" :value="p.partnerTenantId">
                          {{ p.partnerName }}（{{ p.partnerTenantId }}）
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                    <a-col :md="12" :sm="24">
                      <a-button type="primary" @click="loadAliases(1)">查询</a-button>
                      <a-button style="margin-left: 8px" @click="resetAliasQuery">重置</a-button>
                    </a-col>
                  </span>
                </a-row>
              </a-form>
            </div>
            <div class="table-operator" style="margin-top: 5px">
              <a-button v-if="btnEnableList.indexOf(1)>-1" type="primary" icon="plus" @click="handleAddAlias">新增别名</a-button>
              <a-popconfirm
                v-if="btnEnableList.indexOf(1)>-1 && aliasSelectedRowKeys.length > 0"
                title="确定删除选中的别名吗?"
                @confirm="handleBatchDeleteAlias">
                <a-button type="danger" icon="delete">批量删除（{{ aliasSelectedRowKeys.length }}）</a-button>
              </a-popconfirm>
            </div>
            <section>
              <a-table
                size="middle"
                bordered
                rowKey="id"
                :columns="aliasColumns"
                :dataSource="aliasDataSource"
                :pagination="false"
                :scroll="scroll"
                :loading="aliasLoading"
                :rowSelection="{ selectedRowKeys: aliasSelectedRowKeys, onChange: onAliasSelectChange }">
                <template slot="aliasCustomer" slot-scope="text, record">
                  <a-tag v-if="!record.customerTenantId || Number(record.customerTenantId) === 0">通用</a-tag>
                  <span v-else>{{ text }}</span>
                </template>
                <span slot="aliasAction" slot-scope="text, record">
                  <template v-if="btnEnableList.indexOf(1)>-1">
                    <a @click="handleEditAlias(record)">编辑</a>
                    <a-divider type="vertical" />
                    <a-popconfirm title="确定删除该别名吗?"
                                  @confirm="() => handleDeleteAlias(record.id)">
                      <a>删除</a>
                    </a-popconfirm>
                  </template>
                </span>
              </a-table>
            </section>
            <a-pagination
              style="margin-top: 16px; text-align: right"
              :current="aliasPagination.current"
              :pageSize="aliasPagination.pageSize"
              :total="aliasPagination.total"
              @change="aliasPaginationChange"
              @showSizeChange="aliasPaginationShowSizeChange"
            />
          </a-tab-pane>
        </a-tabs>
      </a-card>
    </a-col>

    <!-- ========== 新增/编辑别名弹窗 ========== -->
    <a-modal
      :title="aliasForm.id ? '编辑别名' : '新增别名'"
      :width="500"
      :visible="aliasModalVisible"
      :confirmLoading="aliasSaving"
      :maskClosable="false"
      @ok="handleAliasOk"
      @cancel="aliasModalVisible = false"
      cancelText="取消"
      okText="保存"
      style="top:100px;">
      <a-form>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="客户"
                     extra="通用别名对所有客户生效；客户专属别名仅对该客户的识别/校正生效">
          <a-select v-model="aliasForm.customerTenantId">
            <a-select-option :value="0">通用（所有客户）</a-select-option>
            <a-select-option v-for="p in customerPartnerList" :key="p.partnerTenantId" :value="p.partnerTenantId">
              {{ p.partnerName }}（{{ p.partnerTenantId }}）
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="商品" required>
          <a-select
            placeholder="输入名称搜索商品"
            v-model="aliasForm.materialId"
            show-search
            :filter-option="false"
            @search="handleSearchAliasMaterial">
            <a-select-option v-for="m in aliasMaterialList" :key="m.id" :value="m.id">
              {{ m.unit ? m.name + '（' + m.unit + '）' : m.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="别名" required
                     extra="同一客户下别名唯一，如“洋芋”指向“土豆”，用于识别/校正时自动映射">
          <a-input placeholder="请输入别名" v-model="aliasForm.alias" />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-row>
</template>
<script>
import ItemMapModal from './ItemMapModal'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { deleteItemMap, getPartners, getMaterials, getAliases, addAlias, updateAlias, deleteAlias, deleteAliases } from '@/api/plugin/orderReceive'

export default {
  name: 'ItemMapList',
  mixins: [JeecgListMixin],
  components: {
    ItemMapModal
  },
  data() {
    return {
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18,
        offset: 1
      },
      urlPath: '/plugin/order-receive/itemmap',
      queryParam: {
        materialName: '',
        partnerTenantId: undefined,
        status: undefined
      },
      partnerList: [],
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '合作伙伴',
          dataIndex: 'partnerName',
          width: 160
        },
        {
          title: '本方商品',
          dataIndex: 'materialName',
          width: 160
        },
        {
          title: '对方商品',
          dataIndex: 'partnerMaterialName',
          width: 160,
          customRender: function(text) {
            return text || '-（待对方处理）'
          }
        },
        {
          title: '来源',
          dataIndex: 'source',
          width: 80,
          align: 'center',
          scopedSlots: { customRender: 'source' }
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: 110,
          align: 'center',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 160
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 80,
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/api/plugin/order-receive/item-maps'
      },
      // ===== 别名 Tab 独立状态 =====
      aliasQueryParam: {
        alias: '',
        customerTenantId: undefined
      },
      aliasDataSource: [],
      aliasLoading: false,
      aliasSelectedRowKeys: [],
      // 客户下拉数据（已绑定的客户类型伙伴）
      customerPartnerList: [],
      aliasPagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      aliasColumns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '别名',
          dataIndex: 'alias',
          width: 200
        },
        {
          title: '客户',
          dataIndex: 'customerName',
          width: 140,
          scopedSlots: { customRender: 'aliasCustomer' }
        },
        {
          title: '对应商品',
          dataIndex: 'materialName'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 160
        },
        {
          title: '操作',
          dataIndex: 'aliasAction',
          width: 110,
          align: 'center',
          scopedSlots: { customRender: 'aliasAction' }
        }
      ],
      aliasModalVisible: false,
      aliasSaving: false,
      aliasForm: {
        id: null,
        materialId: undefined,
        customerTenantId: 0,
        alias: ''
      },
      aliasMaterialList: []
    }
  },
  created() {
    this.loadPartners()
    this.loadCustomerPartners()
    this.loadAliases(1)
  },
  methods: {
    getQueryParams() {
      return {
        currentPage: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        materialName: this.queryParam.materialName,
        partnerTenantId: this.queryParam.partnerTenantId,
        status: this.queryParam.status
      }
    },
    searchReset() {
      this.queryParam = { materialName: '', partnerTenantId: undefined, status: undefined }
      this.loadData(1)
    },
    // 查询区伙伴下拉选项（全部已绑定伙伴）
    loadPartners() {
      getPartners({ currentPage: 1, pageSize: 100 }).then((res) => {
        if (res.code === 200) {
          const rows = (res.data && res.data.rows) || []
          this.partnerList = rows
        }
      })
    },
    // 别名客户维度下拉选项（已绑定的客户类型伙伴）
    loadCustomerPartners() {
      getPartners({ partnerType: '客户', currentPage: 1, pageSize: 100 }).then((res) => {
        if (res.code === 200) {
          const rows = (res.data && res.data.rows) || []
          this.customerPartnerList = rows
        }
      })
    },
    handleDelete(id) {
      deleteItemMap(id).then((res) => {
        if (res.code === 200) {
          this.$message.success('删除成功')
          this.loadData()
        } else {
          this.$message.warning(res.message || '删除失败')
        }
      })
    },
    paginationChange(current, pageSize) {
      this.ipagination.current = current
      this.ipagination.pageSize = pageSize
      this.loadData()
    },
    paginationShowSizeChange(current, pageSize) {
      this.ipagination.current = 1
      this.ipagination.pageSize = pageSize
      this.loadData()
    },
    // ===== 别名管理 =====
    loadAliases(arg) {
      if (arg === 1) {
        this.aliasPagination.current = 1
      }
      this.aliasLoading = true
      getAliases({
        currentPage: this.aliasPagination.current,
        pageSize: this.aliasPagination.pageSize,
        alias: this.aliasQueryParam.alias,
        customerTenantId: this.aliasQueryParam.customerTenantId
      }).then((res) => {
        if (res.code === 200) {
          this.aliasDataSource = (res.data && res.data.rows) || []
          this.aliasPagination.total = (res.data && res.data.total) || 0
        } else {
          this.$message.warning(res.message || '查询失败')
        }
        this.aliasLoading = false
      })
    },
    resetAliasQuery() {
      this.aliasQueryParam.alias = ''
      this.aliasQueryParam.customerTenantId = undefined
      this.loadAliases(1)
    },
    aliasPaginationChange(current, pageSize) {
      this.aliasPagination.current = current
      this.aliasPagination.pageSize = pageSize
      this.aliasSelectedRowKeys = []
      this.loadAliases()
    },
    aliasPaginationShowSizeChange(current, pageSize) {
      this.aliasPagination.current = 1
      this.aliasPagination.pageSize = pageSize
      this.aliasSelectedRowKeys = []
      this.loadAliases()
    },
    handleAddAlias() {
      this.aliasForm = { id: null, materialId: undefined, customerTenantId: 0, alias: '' }
      this.aliasMaterialList = []
      this.loadAliasMaterials('')
      this.aliasModalVisible = true
    },
    // 编辑别名：回填后复用新增弹窗
    handleEditAlias(record) {
      this.aliasForm = {
        id: record.id,
        materialId: record.materialId,
        customerTenantId: record.customerTenantId == null ? 0 : Number(record.customerTenantId),
        alias: record.alias
      }
      this.loadAliasMaterials('')
      this.aliasModalVisible = true
    },
    loadAliasMaterials(name) {
      getMaterials({ name: name || '' }).then((res) => {
        if (res.code === 200) {
          const list = res.data || []
          // 编辑回填时确保当前商品出现在下拉选项中
          if (this.aliasForm.id && this.aliasForm.materialId &&
              !list.some((m) => m.id === this.aliasForm.materialId)) {
            list.unshift({ id: this.aliasForm.materialId, name: this.aliasForm.materialName || '', unit: '' })
          }
          this.aliasMaterialList = list
        }
      })
    },
    handleSearchAliasMaterial(value) {
      this.loadAliasMaterials(value)
    },
    handleAliasOk() {
      if (!this.aliasForm.materialId) {
        this.$message.warning('请选择商品')
        return
      }
      if (!this.aliasForm.alias || !this.aliasForm.alias.trim()) {
        this.$message.warning('请输入别名')
        return
      }
      const data = {
        materialId: this.aliasForm.materialId,
        customerTenantId: this.aliasForm.customerTenantId == null ? 0 : this.aliasForm.customerTenantId,
        alias: this.aliasForm.alias.trim()
      }
      this.aliasSaving = true
      const req = this.aliasForm.id ? updateAlias(this.aliasForm.id, data) : addAlias(data)
      req.then((res) => {
        if (res.code === 200) {
          this.$message.success(this.aliasForm.id ? '保存成功' : '新增别名成功')
          this.aliasModalVisible = false
          this.loadAliases(1)
        } else {
          this.$message.warning(res.message || '保存失败')
        }
      }).finally(() => {
        this.aliasSaving = false
      })
    },
    onAliasSelectChange(selectedRowKeys) {
      this.aliasSelectedRowKeys = selectedRowKeys
    },
    handleBatchDeleteAlias() {
      if (!this.aliasSelectedRowKeys.length) {
        return
      }
      const ids = this.aliasSelectedRowKeys.slice()
      deleteAliases(ids).then((res) => {
        if (res.code === 200) {
          this.$message.success('删除成功')
          this.aliasSelectedRowKeys = []
          this.loadAliases()
        } else {
          this.$message.warning(res.message || '删除失败')
        }
      })
    },
    handleDeleteAlias(id) {
      deleteAlias(id).then((res) => {
        if (res.code === 200) {
          this.$message.success('删除成功')
          // 同步清掉该行在批量选择中的残留
          this.aliasSelectedRowKeys = this.aliasSelectedRowKeys.filter((k) => k !== id)
          this.loadAliases()
        } else {
          this.$message.warning(res.message || '删除失败')
        }
      })
    }
  }
}
</script>
<style scoped>
.table-page-search-wrapper { margin-bottom: 15px; }
.table-operator { margin-bottom: 15px; }
</style>
